import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
  console.log('triggers init')
}

export async function list(app, apiHost, pageNo = 1) {
  const URL = `${getChatApiBase(app, apiHost)}/triggers?per_page=${
    constants.perPageInListings
  }&page=${pageNo}`
  return axios
    .get(`${URL}`, {
      headers: { ...getChatApiHeaders(app), 'X-Legacy-Webhook': true },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}
export async function listNew(app, apiHost, pageNo = 1) {
  const URL = `${getChatApiBase(app, apiHost)}/triggers?per_page=${
    constants.perPageInListings
  }&page=${pageNo}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}
